import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ReactNode } from "react";

interface AuditCardMetric {
  icon: ReactNode;
  label: string;
  value: ReactNode;
  iconClassName?: string;
}

interface AuditCardProps {
  title: string;
  description: string;
  metrics: AuditCardMetric[];
}

export const AuditCard = ({ title, description, metrics }: AuditCardProps) => {
  return (
    <Card className="w-[420px]">
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
        <CardDescription className="text-muted-foreground">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent className="px-6 pt-2">
        <div className="flex gap-8">
          {metrics.map((metric) => (
            <div key={metric.label} className="flex min-w-0 items-start gap-1.5">
              <span className={metric.iconClassName}>{metric.icon}</span>
              <div className="min-w-0 ml-1">
                <div className="text-sm font-semibold leading-none tabular-nums">{metric.value}</div>
                <div className="mt-2 text-sm text-muted-foreground">{metric.label}</div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
